import React from 'react';
import LinkedInIcon from './icons/LinkedinIcon';
import GithubIcon from './icons/GithubIcon';

const SocialLink = ({ children, href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-gray-500 hover:text-white transition-colors duration-300"
  >
    {children}
  </a>
);

const Footer = () => {
  return (
    <footer className="border-t border-[#1C1D20] pt-8 flex items-center justify-between">
      <p className="text-sm text-gray-500">Copyright ©  {new Date().getFullYear()} mizmeg.com</p>
      <div className="flex items-center space-x-6">
        <SocialLink href="https://www.linkedin.com/in/megumimizuno/">
          <LinkedInIcon className="w-5 h-5" />
        </SocialLink>
        <SocialLink href="https://github.com/komegi1215">
          <GithubIcon className="w-5 h-5" />
        </SocialLink>
        {}
      </div>
    </footer>
  );
};

export default Footer;
